export default "__VITE_ASSET__B58Hk1WD__"